import {httpDelete, httpGet, httpPatch, httpPost, httpPut} from "../libs/http";

export const loadIPAddressGroups = (page, per_page, filter = null, onSuccess = null, onFailure = null) => dispatch => {
    httpGet('/ip-addresses/groups/?page=' + page + '&per_page=' + per_page, (res) => onSuccess(res), (err) => onFailure(err));
};

export const getIpAddressGroupDetails = (guid, onSuccess, onFailure) => dispatch => {
    httpGet('/ip-addresses/groups/' + guid + '/', (res) => onSuccess(res), (err) => onFailure(err));
};

export const updateIPAddressGroup = (guid, data, onSuccess, onFailure) => dispatch => {
    httpPut('/ip-addresses/groups/' + guid + '/',  data, (res) => onSuccess(res), (err) => onFailure(err));
};

export const getIpAddressGroupIPAddresses = (guid, page, per_page, searchQuery, filters, onSuccess, onFailure) => dispatch => {
    console.log(guid, page, per_page, searchQuery, filters)

    let search = [];

    for(let i = 0; i < searchQuery.length; i++) {
        search.push('search=' + searchQuery[i]);
    }

    let search_param = '';

    if(search.length > 0) {
        search_param = '&' + search.join('&')
    }

    let filter_param = '';

    if(filters !== null) {
        let filter_keys = Object.keys(filters);

        for(let i = 0; i < filter_keys.length; i++) {
            if(filters[filter_keys[i]] !== null) {
                for(let j = 0; j < filters[filter_keys[i]].length; j++) {
                    filter_param += '&' + filter_keys[i] + '=' + filters[filter_keys[i]][j];
                }
            }
        }
    }

    httpGet('/ip-addresses/?group=' + guid + '&page=' + page + '&per_page=' + per_page + search_param + filter_param, (res) => onSuccess(res), (err) => onFailure(err));
};


export const createIpAddressGroup = (name, onSuccess, onFailure) => dispatch => {
    httpPost('/ip-addresses/groups/', { name }, (res) => onSuccess(res), (err) => onFailure(err));
};

export const deleteIPAddressGroup = (guid, onSuccess, onFailure) => dispatch => {
    httpDelete('/ip-addresses/groups/' + guid + '/', (res) => onSuccess(res), (err) => onFailure(err));
};

export const loadAllIPAddresses = (onSuccess, onFailure) => dispatch => {
    httpGet('/ip-addresses/?page=1&per_page=99999', (res) => onSuccess(res), (err) => onFailure(err));
};

export const loadAllIPSignatures = (onSuccess, onFailure) => dispatch => {
    httpGet('/ip-addresses/signatures/?per_page=99999', (res) => onSuccess(res), (err) => onFailure(err));
};

export const loadAvailableIPAddresses = (ip_type, ip_filter, excluded_ip_groups, currency, onSuccess = null, onFailure = null) => dispatch => {
    let excluded = [];

    for(let i = 0; i < excluded_ip_groups.length; i++) {
        excluded.push('exclude=' + excluded_ip_groups[i]);
    }

    let excluded_param = '';

    if(excluded.length > 0) {
        excluded_param = '&' + excluded.join('&')
    }

    httpGet('/ip-addresses/marketplace/?ip_type=' + ip_type + '&ip_filter=' + ip_filter + '&currency=' + currency + excluded_param, (res) => onSuccess(res), (err) => onFailure(err));
};

export const createIPAddressOrder = (data, onSuccess, onFailure) => dispatch => {
    httpPost('/billing/orders/ip-addresses/create/', data, (res) => onSuccess(res), (err) => onFailure(err));
};

export const createQuickIPAddressOrder = (data, onSuccess, onFailure) => dispatch => {
    httpPost('/billing/orders/ip-addresses/quick-create/', data, (res) => onSuccess(res), (err) => onFailure(err));
};

export const loadIPAddressMapData = (onSuccess, onFailure) => dispatch => {
    httpGet('/ip-addresses/map/', (res) => onSuccess(res), (err) => onFailure(err));
};

export const updateIPAddress = (ip_address, data, onSuccess, onFailure) => dispatch => {
    httpPut('/ip-addresses/' + ip_address + '/', data, (res) => onSuccess(res), (err) => onFailure(err));
};

export const moveIPAddresses = (data, onSuccess, onFailure) => dispatch => {
    httpPatch('/ip-addresses/', data, (res) => onSuccess(res), (err) => onFailure(err));
};

export const exportIPAddressData = (guid, fields, selectedIPAddresses, type, sortField, sortDir, onSuccess, onFailure) => dispatch => {
    let urlFields = [];

    for(let i = 0; i < fields.length; i++) {
        urlFields.push('fields=' + fields[i]);
    }

    let domains = [];

    for(let i = 0; i < selectedIPAddresses.length; i++) {
        domains.push('selected_ip-addresses=' + selectedIPAddresses[i]);
    }

    httpGet('/ip-addresses/export/?group=' + guid + '&output_type=' + type + '&' + urlFields.join('&') + '&' + domains.join('&') + '&sort_field=' + sortField + '&sort_dir=' + sortDir, (res) => onSuccess(res), (err) => onFailure(err));
};

export const setHttpVersion = (guid, data, onSuccess, onFailure) => dispatch => {
    httpPost('/ip-addresses/' + guid + '/http_version/', data, (res) => onSuccess(res), (err) => onFailure(err));
};
export const setDirectAccess = (guid, data, onSuccess, onFailure) => dispatch => {
    httpPost('/ip-addresses/' + guid + '/direct_access/', data, (res) => onSuccess(res), (err) => onFailure(err));
};

export const bulkIPAddressActions = (data, onSuccess, onFailure) => dispatch => {
    httpPost('/ip-addresses/bulk/', data, (res) => onSuccess(res), (err) => onFailure(err));
};

export const loadIPAddressBillingCycles = (onSuccess = null, onFailure = null) => dispatch => {
    httpGet('/billing/orders/ip-addresses/options/', (res) => onSuccess(res), (err) => onFailure(err));
};
